import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useState } from "react";
import postDataTrace from "../../../../services/postDataTrace";

export default function CreateRole({
  isVisible,
  hideModal,
  handleFetchRoles,
}: any) {
  const [isLoading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const onSubmit = async () => {
    setLoading(true);
    const { name } = await form.getFieldsValue();
    const data = { isActive: true, name };
    const uri = `roles`;
    const response = await postDataTrace(data, uri);
    if (response.success) {
      message.success("Created Successfully");
      handleFetchRoles();
      form.resetFields();

      hideModal();
    } else {
      message.error(response.message);
    }
    setLoading(false);
  };

  const clearForm = async () => {
    form.resetFields();
    setLoading(false);
  };

  return (
    <Modal
      visible={isVisible}
      title="New Role"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createRole"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createRole"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter role",
                },
              ]}
            >
              <Input placeholder="Role" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
